import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, message, Row, Spin, Tabs} from 'antd';
import {ProForm, ProFormInstance} from '@ant-design/pro-form';
import {WdiCardTitle, wdiCore, WdiInput, WdiStaffCard} from '@/components/WdiControls';
import {FormPageProps, WdiFormPageTitle} from '@/components/WdiBus/FormPage';
import {FileUploadUtility, WdiFileList} from '@/components/WdiControls/WdiFileUpload';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {FormSaMktDetailsForApprovalPanel} from '@/pages/mkt/sa/MktApply/components/Detail';
import {ResponseStatus} from '@/utils/request';
import {FormSaMktAllocateCc, FormSaMktAllocateMonth, FormSaMktDetail} from '@/services/mkt/sa';
import FormSaMktAllocateMonthDetail from '@/pages/mkt/sa/MktApply/components/DetailAllocate';
import {
  addAllocateAmount,
  getFormStatusName,
  initApprovalPageContext,
  ViewEntityProps
} from '@/pages/mkt/sa/components/data';
import DataStore from '@/components/GridWidget/DataStore';
import {Enum} from '@/enums/system';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import BudgetInformation from '@/pages/mkt/sa/components/BudgetInformation';
import FormSaMktDetailAllocateCcApp from "@/pages/mkt/sa/MktApply/components/DetailAllocateBo";
import DynamicInformation from "@/pages/mkt/sa/components/DynamicInformation";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";


const moreConfig: any = {
  successParams: [
    {
      url: '/basicapi/favorite/getButtons',
      keys: [],
    }, {
      url: '/expenseapi/saMktButtons/get',
      keys: [
        'UndoButton',
        'ReeditButton',
        'CancelButton',
        'SupplementFileButton',
        'CopyButton',
        'InterveneFlowButton',
        'ClosedButton',
        'UpdateApplyButton',
        'PrePaymentButton',
        'PaymentButton',
        'ModifyAmountButton',
        'AppendExtNodeButton',
        'OpenedButton',
        'AddMailApproverButton',
        "ExpediteFlowButton",
      ]
    }
  ],
  errorParams: [
    {
      url: "/expenseapi/saMktButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};

const approvalConfig: any = {
  params: {
    url: "/expenseapi/saMktButtons/get",
    keys: [
      "ApprovalButton",
      "ReadButton",
    ]
  }
};


const MktApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  const [entity, setEntity] = useState<ViewEntityProps>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [formSaMktAllocateMonths, setFormSaMktAllocateMonths] = useState<any[]>([]);
  const [formSaMktAllocateCcs, setFormSaMktAllocateCcs] = useState<any[]>([]);
  const [activeKey, setActiveKey] = useState<string>("1");
  useEffect(() => {
    if (!formRef?.current) {
      return;
    }
    setActiveKey(props.data?.defaultActiveKey ?? "1");
  }, [!!(formRef?.current)])

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApprovalPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;
        if (viewEntity.form) {
          formRef.current?.setFieldsValue({
            isSpecialApprove: viewEntity.form.isSpecialApprove
          })
        }
        if (viewEntity.formSaMkt) {
          formRef.current?.setFieldsValue({
            activityName: viewEntity.formSaMkt?.activityName,
            activityDate: wdiCore.String.Join(viewEntity.formSaMkt?.activityStartDate, viewEntity.formSaMkt?.activityEndDate),
            bohqId: viewEntity.formSaMkt.bohqId,
            bohqName: viewEntity.formSaMkt.bohqName,
            remark: viewEntity.formSaMkt?.remark,
            oaFormNo: viewEntity.formSaMkt?.oaFormNo,
            fileInfo: FileUploadUtility.parse(viewEntity.formSaMkt?.fileName, viewEntity.formSaMkt?.filePath),
            fileAddInfo: FileUploadUtility.parse(viewEntity.formSaMkt?.fileNameAdd, viewEntity.formSaMkt?.filePathAdd),
          });
        }
        setEntity(viewEntity);
        if (!viewEntity.formSaMkt?.formSaMktId) return;
        if (viewEntity.formSaMkt?.formSaMktId) {
          const res = await FormSaMktDetail.getsEx(viewEntity.formSaMkt?.formSaMktId)
          setDataSource(DataStore.init(res.data));
          FormSaMktAllocateMonth.gets(viewEntity.formSaMkt?.formSaMktId || 0).then((responseAllocateMonth) => {
            setFormSaMktAllocateMonths(addAllocateAmount(responseAllocateMonth.data, res.data, 'shareRate'));
          });
          FormSaMktAllocateCc.gets(viewEntity.formSaMkt?.formSaMktId || 0).then(responseAllocateCc => {
            setFormSaMktAllocateCcs(addAllocateAmount(responseAllocateCc.data, res.data, 'shareRate'));
          });
        } else {
          setDataSource(DataStore.init([]));
          setFormSaMktAllocateMonths(DataStore.init([]));
        }
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = `广告类活动申请单【${entity.form?.formNo}】`;
      getFormStatusName(entity).then(response => {
        title += `,${response}`;
        if (entity?.form?.relationType === 2) {
          title += '（变更申请）';
        }
        if (props.setPageTitle) props.setPageTitle(
          <WdiFormPageTitle
            title={title}
            onClose={props.onClose}
            callback={props.callback}
            form={entity?.form}
            useCaseId={Enum.UseCase.SA_MKT}
            moreConfig={moreConfig}
            approvalConfig={approvalConfig}/>
        );
      });
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <WdiStaffCard formId={entity?.form?.formId}/>
      <Tabs activeKey={activeKey} onTabClick={(key, _) => setActiveKey(key)} size="large">
        <TabPane tab={<span>活动信息</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => {
                return (<></>);
              },
            }}
          >
            <WdiPanel title={<WdiCardTitle title='活动基本信息'/>}>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={8}>
                  <Form.Item name="activityName" label="活动名称">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item name="activityDate" label="活动期间">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                {/*                <Col className="gutter-row" span={4}>
                  <Form.Item name="oaFormNo" label="OA方案号">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>*/}
                <Col className="gutter-row" span={8}>
                  <Form.Item name="bohqName" label="预算归属">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={16}>
                  <Form.Item name="remark" label="方案简述">
                    <WdiEditor readOnly={true}/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="fileInfo"
                    label="附件"
                    valuePropName='fileList'
                    getValueFromEvent={(e: any) => {
                      return e.fileList || [];
                    }}
                  >
                    <WdiFileList/>
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
            <FormSaMktDetailsForApprovalPanel
              form={entity?.form}
              dataSource={dataSource}
            />
            <FormSaMktAllocateMonthDetail
              readonly={true}
              dataSource={formSaMktAllocateMonths}/>
            <FormSaMktDetailAllocateCcApp
              readonly={true}
              dataSource={formSaMktAllocateCcs}/>
          </ProForm>
        </TabPane>
        <TabPane tab={<span>预算信息</span>} key="2">
          <BudgetInformation formId={entity?.form?.formId}/>
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="4">
          {
            entity?.form ? <DynamicInformation
              formId={entity?.form?.formId}
              formTypeId={entity?.form?.formTypeId}
              pageTypeId={entity?.form?.pageTypeId}
              useCaseId={Enum.UseCase.SA_MKT}
            /> : <Spin/>
          }
        </TabPane>
      </Tabs>
    </>
  );
};
export default MktApprovalApp;
